import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getAll } from 'apis/projectProposals.api';

const useGetAll = (pagination, filters, showMode, conds) => {
  const { data: _data, ...rest } = useQuery(
    ['getAllProjectProposal', pagination, filters, showMode],
    () => getAll(pagination, filters, showMode),
    {
      ...conds,
    }
  );

  const data = useMemo(
    () => _data?.data ?? { data: [], pagination: { row: 10, totalRecords: 0 } },
    [_data]
  );
  return {
    data,
    ...rest,
  };
};

export default useGetAll;
